type FetchValue = {
  page: number;
  size: number;
  total: number;
  name?: string;
};

type FetchValueUpdate = {
  page?: number;
  size?: number;
  total?: number;
  name?: string;
};

export default function fetchValueReducer(
  data: FetchValue,
  action: { type: 'update'; value: FetchValueUpdate },
): FetchValue {
  switch (action.type) {
    case 'update':
      return {
        ...data,
        ...action.value,
      };
  }
}
